import { useState } from 'react';
import Button from 'components/ui-components/Button';
import ContentfulImageRenderer from 'contentful/image_renderer';

const SponsorsGrid = ({ title, sponsors, btnText }) => {
  const [expanded, setExpanded] = useState(false);

  const displayLimit = 10;

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <div className="event__sponsors">
      {title && <h2>{title}</h2>}
      <div className="event__sponsors__grid">
        {sponsors
          .slice(0, expanded ? sponsors.length : displayLimit)
          .map(({ fields: { url, image } = {}, sys: { id } }) => {
            const SponsorWrapper = url ? 'a' : 'div';
            return (
              <SponsorWrapper
                key={id}
                href={url}
                target={url && '_blank'}
                rel={url && 'noreferrer'}
                className="event__sponsors__item">
                <ContentfulImageRenderer image={image} />
              </SponsorWrapper>
            );
          })}
      </div>
      {sponsors.length > displayLimit && !expanded && (
        <Button
          className="cef-btn cef-btn--small-feature cef-btn--red width-100 m-width-auto cef-btn--xxl mt-40 margin-center"
          handleClick={toggleExpanded}>
          {btnText}
        </Button>
      )}
    </div>
  );
};

export default SponsorsGrid;
